import React, { CSSProperties } from "react";
import { Box, Text } from "@chakra-ui/react";

type LightGemProps = {
  text: string;
  color?: string;
  textColor?: string;
  onClick?: () => void;
  isPointer?: boolean;
  borderRadius?: string;
  sx?: CSSProperties;
};

const LightGem: React.FC<LightGemProps> = ({
  text,
  color,
  textColor,
  onClick,
  isPointer,
  borderRadius = "5px",
  sx = {},
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        cursor: isPointer ? "pointer" : " default",
        bg: color,
        width: "32px",
        height: "32px",
        borderRadius: borderRadius,
        alignItems: "center",
        textAlign: "center",
        ...sx,
      }}
    >
      <Text verticalAlign="center" my="auto" color={textColor} lineHeight="2">
        {text}
      </Text>
    </Box>
  );
};

export default LightGem;
